export let English =
    {
        "Home":"Home",
        "MyAccount":"My Account",
        "WatchLater":"Favorites",
        "VideoOnDemand":"Video On Demand",
        "Notifications":"Notifications",
        "History":"History",
        "AllCategories":"All Categories",
        "TVSeries":"TV Series",
        "Movie":"Movie",
        "Documentaries":"Documentaries",
        "ViewAll":"View All",
        "Rate":"Rate",
        "Autoplay":"Autoplay",
        "RelatedVideos":"Related Videos",
        "Play":"Play",
        "Director":"Director",
        "Writer":"Writer",
        "About":"About",
        "PrivacyPolicy":"Privacy Policy",
        "Term&Conditions":"Term & Conditions",
        "Search":"Search",
        "Cancel":"Cancel",
        "NoVideosAddedToWatchLaterYet":"No Videos Added To Favorites Yet",
        "Addyourfavoritevideostoaccessandwatcheasilywithoutanyhassles":"Add your favorite videos to access and watch easily without any hassles.",
        "ExploreVideos":"Explore Videos",
        "SayHelloToTheFutureofMobiletainment":"",
        "AllWatchLater":"All Favorites",
        "ShowMore":"Show More",
        "Clear":"Clear",
        "NoHistoryVideosYet":"No History Video Yet",
        "AccountDetails":"Account Details",
        "Name":"Name",
        "EmailAddress":"Email Address",
        "Location":"Location",
        "Interests":"Interests",
        "Choose3Categories":"Choose Your Genre",
        "Sports":"Sports",
        "Action":"Action",
        "Adventure":"Adventure",
        "Fitness":"Fitness",
        "Entertainment":"Entertainment",
        "GeneralSettings":"General Settings",
        "AccountType":"Account Type",
        "Premium":"Premium",
        "Timezone":"Timezone",
        "EditPhoto":"Edit Photo",
        "Save":"Save",
        "Profiledetailsaved":"Profile detail saved",
        "Successfullyaddedtoyourwatchlater":"Successfully added to your favorites",
        "Successfullyremovedfromyourwatchlater":"Successfully removed from your favorites",
        "Watchwithnolimits":"Watch with no limits",
        "Standard":"Standard",
        "ShowLess":"Show Less",
        "Namecannotbeempty":"Name can not be empty",
        "EmailAddresscannotbeempty":"Email Address can not be empty",
        "Locationcannotbeempty":"Location cannot be empty",
        "Profilepicturesaved":"Profile Picture Saved",
        "PlayDisable":"Not available in demo"
    }


// WEBPACK FOOTER //
// ./src/constants/english.js